import { Core } from "@faire/design-tokens";
import { NoSSR } from "@faire/web--source/common/NoSSR";
import { Add } from "@faire/web--source/slate/icons/foundation/Add";
import React from "react";
import { Suspense } from "react";

import { QuickAddProps } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/QuickAddProps";
import { DeferRenderedQuickAddBase } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/Search/__internal__/DeferRenderedQuickAddBase";

/**
 * This component is used on product with brand tiles for 
PERSIST_QUICK_ADD_ON_SEARCH_TILE_241029 xp.
 */
export const DeferRenderedQuickAdd = ({ data }: { data: QuickAddProps }) => {
  return (
    <NoSSR serverRenderFallback={<QuickAddPlaceholder />}>
      <Suspense fallback={<QuickAddPlaceholder />}>
        <DeferRenderedQuickAddBase data={data} />
      </Suspense>
    </NoSSR>
  );
};

const QuickAddPlaceholder = () => {
  return (
    <div className="absolute bottom-0 right-0 p-[8px]">
      <div className="bg-core-surface-inverse flex h-[32px] w-[32px] items-center justify-center rounded-full p-1">
        <Add color={Core.text.primary} />
      </div>
    </div>
  );
};
